<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card(min-height="80vh")
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text Add customer
        v-card-text.pa-0
          .customers
            .background-header
              v-container.pa-0(style="max-width:600px")
                div.my-2.mx-4
                  v-text-field(v-model="searchText" placeholder='Search customer' hide-details dense outlined height="40" background-color="basic200")
                    template(v-slot:append)
                      eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
                div.px-4
                  v-layout(@click="clickSelect({ name: 'Guest' })" style="cursor: pointer")
                    v-layout.mt-1(style="height: 56px; max-width: 30px; min-width: 30px; margin-right: 12px;")
                      eva-icon.ma-auto(name="person-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic600")
                    v-layout.py-4
                      div.my-auto
                        .s1.basic800--text Guest
                        .c1.basic600--text Select this when you do not wish to collect customer info.
                div.px-4.py-2(:style="{ 'background-color' : $vuetify.theme.themes[$theme].basic600T08}")
                  .s2.primary400--text.text-uppercase Customers
                div.my-2.mx-4
                  v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="openCustomer(null)")
                    eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
                    | Create New Customer
              v-container.pa-0.mb-4(style="max-width:600px")
                v-layout.my-6(v-if="isFetching")
                  v-row.fill-height.ma-0(align='center' justify='center')
                    v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
                .contain-layout(v-else)
                  v-layout.my-6(v-if="customers.length == 0")
                    v-row.fill-height.ma-0(align='center' justify='center')
                      div.mx-auto
                        v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                        p.caption Customers not found or empty
                  .items-layout.mx-2(v-else)
                    v-divider.basic300
                    template(v-for='(customer, index) in customers')
                      v-row(no-gutters @click="clickSelect(customer)")
                        v-col.py-3.px-2.pr-2
                          .customer-title.p1.basic800--text.mb-1 {{ customer.name }}
                          .customer-phone.c1.basic600--text.mb-1 {{ customer.phone | phoneFormat }}
                          .customer-email.c1.basic600--text.mb-1 {{ customer.email }}
                        v-col.py-3.pr-2.shrink(style="min-width:87px" align="right" @click.stop="openCustomer(customer)")
                          .button-Aa-small.info500--text Edit
                      v-divider.basic300
                y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

    .modals
      AddCustomer(v-if="showAddCustomerDialog" :open.sync="showAddCustomerDialog" :parentCustomer="openingCustomer" @added="handleAddItem" @edited="handleEditItem" :company="company")

</template>

<script>
import { mapGetters } from 'vuex'
import queryString from 'query-string'
import AddCustomer from '@/components/yezzabook/dialogs/income/addincome/AddCustomer.vue'

export default {
  name: 'addCustomersDialog',
  components: { AddCustomer },
  props: ['open'],
  data: () => ({
    showAddCustomerDialog: false,
    isFetching: false,
    pageSize: 10,
    count: 0,
    page: 1,
    customers: [],
    searchText: '',
    openingCustomer: null,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchCustomers(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        if (this.page === 1) {
          this.fetchCustomers(1)
        }
        this.page = 1
      }, 500)
    },
  },
  mounted () {
    this.fetchCustomers(1)
  },
  methods: {
    fetchCustomers(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/books/${this.company.slug}/customers/?page=${page}&page_size=${this.pageSize}&ordering=-id`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.customers = response.data.results
        this.count = response.data.count
      }).catch(() => {})
    },
    openCustomer (customer) {
      this.openingCustomer = customer
      this.showAddCustomerDialog = true
    },
    handleAddItem (item) {
      this.customers.splice(0, 0, item)
    },
    handleEditItem (item) {
      let addToIndex = 0
      this.customers.forEach((customer, index) => {
        if (customer.id === item.id) {
          addToIndex = index
        }
      })
      this.customers = this.customers.filter((x) => x.id !== item.id)
      this.customers.splice(addToIndex, 0, item)
    },
    clickSelect (customer) {
      this.$emit("confirm", customer)
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.customer-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.customer-description {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>

<i18n>
{
  "en": {
    "item": "No item | {n} item |  {n} items",
    "cancel": "Cancel",
    "confirm": "Confirm"
  }
}
</i18n>
